var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPic2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 174,
    viewBox: "0 0 312 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 312,
    height: 174,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225 87.0098C225 91.9106 224.491 96.7038 223.533 101.321L198.031 116.346V142.219C186.156 151.483 171.228 157 155 157C116.342 157 85 125.668 85 87.0098C85 48.3513 116.342 17.0196 155 17.0196C193.658 17.0196 225 48.3513 225 87.0098Z",
    fill: "#276EF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M181.343 67.211L166.406 87.4793L170.7 100.881C172.226 105.635 170.299 110.819 166.054 113.431C164.127 114.615 161.603 113.812 160.713 111.739L151.527 90.2672C149.982 86.7261 150.324 82.6372 152.427 79.3994L166.298 58.0257L181.343 67.211Z",
    fill: "#FF9C75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.192 80.5537L176.364 99.834L181.852 102.906C183.828 103.962 185.432 105.517 186.527 107.366C187.633 109.225 188.229 111.367 188.21 113.607C188.19 115.485 186.195 116.688 184.522 115.828L169.419 109.195C166.69 108.002 164.743 105.517 164.234 102.583L160.879 83.2339L174.192 80.5537Z",
    fill: "#FF9C75"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.039 62.1537L153.102 82.422L157.387 95.8234C158.913 100.577 156.986 105.762 152.74 108.374C150.813 109.557 148.29 108.755 147.399 106.681L138.224 85.2197C136.678 81.6786 137.021 77.5897 139.124 74.3519L152.995 52.9782L168.039 62.1537Z",
    fill: "#FF9C75"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M169.458 71.7596L144.846 66.4382L134.38 75.8387C130.662 79.1744 125.155 79.5461 121.027 76.7387C119.159 75.467 118.856 72.8357 120.391 71.1727L136.219 54.0053C138.821 51.149 142.684 49.7795 146.499 50.3762L171.669 54.2694L169.458 71.7596Z",
    fill: "#FF9C75"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M187.975 25.256V72.7379H105.415C102.891 72.7379 100.847 70.6934 100.847 68.1697V25.256H187.975Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M146.411 43.069H179.817",
    stroke: "#AFAFAF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.758 35.6836H146.48",
    stroke: "#AFAFAF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.186 58.0648H172.441",
    stroke: "#AFAFAF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M146.411 50.4544H179.817",
    stroke: "#AFAFAF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M110.13 41.2202L110.12 41.2104H110.11L110.13 41.2202Z",
    fill: "#9CC0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M110.13 41.2202V41.1909L110.12 41.2105L110.13 41.2202Z",
    fill: "#9CC0FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.13 41.2202L110.11 41.2104L110.101 41.2202H110.13Z",
    fill: "#9CC0FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M191.555 72.7378L185.373 64.2275C182.38 60.1093 178.301 56.9106 173.586 54.9835L152.3 46.6297C148.563 45.1037 144.475 47.8133 144.416 51.8435C144.308 59.3756 148.818 66.2132 155.792 69.0696L165.388 72.6791L191.555 72.7378Z",
    fill: "#FFC6AF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M223.494 101.409C221.009 97.2124 219.278 92.5758 218.397 87.7239L212.929 57.4779C211.657 50.4349 206.404 44.7809 199.479 42.9908L187.975 40.0171L188.014 72.7379L177.137 62.8483L154.09 68.0327L160.096 70.4978C163.432 71.8673 165.907 74.7432 166.768 78.2451L178.115 124.534C180.453 134.081 188.464 141.036 198.041 142.2C200.281 140.449 202.443 138.571 204.507 136.507C214.484 126.529 220.804 114.272 223.494 101.409Z",
    fill: "#FFC6AF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.975 58.7887L188.004 67.2893C189.579 69.4609 193.013 68.3359 192.993 65.6557C192.974 62.9754 191.448 60.5299 189.061 59.3267L187.975 58.7887Z",
    fill: "#FF9C75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.857 25.256H187.975V21.5682C187.975 19.0444 185.931 17 183.407 17H105.415C102.891 17 100.847 19.0444 100.847 21.5682V25.256H100.857Z",
    fill: "#A0BFF9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.42 34.0989H109.426V63.0928H138.42V34.0989Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123.923 48.547C126.813 48.547 129.156 46.2039 129.156 43.3136C129.156 40.4233 126.813 38.0802 123.923 38.0802C121.032 38.0802 118.689 40.4233 118.689 43.3136C118.689 46.2039 121.032 48.547 123.923 48.547Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M132.541 59.1996H115.305V56.1769C115.305 53.076 117.819 50.5621 120.919 50.5621H126.916C130.017 50.5621 132.531 53.076 132.531 56.1769V59.1996H132.541Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPic2);
export default __webpack_public_path__ + "static/media/pic2.34e9195e147e7f2c54085cce2272d1ee.svg";
export { ForwardRef as ReactComponent };